module.exports = __webpack_public_path__ + "static/img/placholder_1200.eeda8f50.svg";